import { NOTIFICATION_NAME } from './constants';
import { tradeProgramAnnouncementModalRule } from './tradeProgramAnnouncementModalRule';
import { tradeProgramAnnouncementModalAction } from './tradeProgramAnnouncementModalAction';

export default {
    name: NOTIFICATION_NAME,
    priority: 447,
    rule: tradeProgramAnnouncementModalRule,
    action: tradeProgramAnnouncementModalAction,
};
